// O6 · Here's what I've got (QO6_GotYou): a light paper card with the four answers, the reassurance line,
// "That's me" (progress 75 -> 82, then O7) and "Change something" (back to O2).
import { useEffect, useRef, useState } from 'preact/hooks';
import { OB_GOT_YOU, OB_GOT_YOU_NOTE } from '@shared/content/lines';
import { Screen, Icon, OnbTopBar, PrimaryButton, TextButton, ScrollArea, type IconName } from '../../components';
import { back, go } from '../../router';
import { progress, useDraft } from './draft';
import s from './O6GotYou.module.css';

const cap = (x: string) => x.charAt(0).toUpperCase() + x.slice(1);

export function O6GotYou() {
  const ob = useDraft((d) => d.ob);
  const [yes, setYes] = useState(false);
  const tm = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => { if (tm.current) clearTimeout(tm.current); }, []);
  const rows: { label: string; value: string; icon: IconName }[] = [
    { label: 'YOU WANT TO', value: ob.change || (ob.changeSaid ? `"${ob.changeSaid}"` : 'Get work done on time'), icon: 'star' },
    { label: 'HARD PART', value: ob.stuck || 'Starting', icon: 'mountain' },
    { label: 'TALK TO YOU', value: ob.tone.length ? ob.tone.join(' + ') : 'Straight to the point', icon: 'chat' },
    { label: 'CHECK-INS', value: cap(ob.checkin || 'steady'), icon: 'bell' },
  ];
  return (
    <Screen theme="pre" bg="#100E0C" id="O6">
      <div class={s.glow} aria-hidden="true" />
      <OnbTopBar pct={progress('O6', yes)} onBack={() => back('O5')} />
      <ScrollArea class={s.body} fadeTop={16}>
        <h1 class={s.h1}>Here's what I've got.</h1>
        <div class={s.card}>
          {rows.map((r) => (
            <div key={r.label} class={s.row}>
              <span class={s.icon} aria-hidden="true"><Icon name={r.icon} size={20} color="#8A6512" /></span>
              <span class={s.text}><span class={s.label}>{r.label}</span><span class={s.value}>{r.value}</span></span>
            </div>
          ))}
        </div>
        <p class={s.note}>{OB_GOT_YOU[ob.stuck || 'Starting'] || OB_GOT_YOU_NOTE}</p>
      </ScrollArea>
      <div class={s.actions}>
        <PrimaryButton data-cta="thats-me" onClick={() => {
          if (yes) return;
          setYes(true);
          tm.current = setTimeout(() => go('O7'), 450);
        }}>That's me</PrimaryButton>
        <TextButton onClick={() => go('O2')}>Change something</TextButton>
      </div>
    </Screen>
  );
}
